import * as Sentry from '@sentry/browser';

// Shared web error reporter. Onboarding auth/save failures are caught (handled)
// and never reach a global error handler, so today they are invisible (HTTP 200,
// no web telemetry). This wires those handled failures to Sentry.
//
// init runs once at app startup (src/index.js). When no DSN is configured (e.g.
// local dev) Sentry is never initialized, so reportHandledError() falls back to
// console.error only — no network noise.
let initialized = false;

export function initErrorReporter() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || initialized) return false;
  try {
    Sentry.init({ dsn, environment: process.env.REACT_APP_ENV || 'production' });
    initialized = true;
    return true;
  } catch (e) {
    // Telemetry init must NEVER break app startup (this runs at module top in
    // index.js, before render). If Sentry fails to init, the app still mounts.
    // eslint-disable-next-line no-console
    console.error('[errorReporter] init failed', e);
    return false;
  }
}

export function reportHandledError(error, context) {
  // eslint-disable-next-line no-console
  console.error('[onboarding] handled failure', error, context || '');
  if (initialized && error) {
    try {
      Sentry.captureException(error, {
        tags: { area: (context && context.area) || 'onboarding', step: context && context.step },
        extra: context || {},
      });
    } catch (e) {
      // Telemetry must NEVER break the recovery path it observes. This runs as
      // the first statement in the onboarding catch blocks; a throw here would
      // abort persistDraft + createErrorAlert and re-create the silent strand.
      // eslint-disable-next-line no-console
      console.error('[errorReporter] captureException failed', e);
    }
  }
}

export function isErrorReporterInitialized() {
  return initialized;
}
